var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.seasonArr),function(season){return _c('li',{key:season.id,on:{"click":function($event){return _vm.changeSeason(season.englishName)}}},[_vm._v(" "+_vm._s(season.name)+"-"+_vm._s(season.englishName)+" ")])}),0),_c('div',{staticClass:"season"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }